import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading, onboardingCompleted, privacyAccepted, acceptPrivacy } =
    useAuth();
  const location = useLocation();

  // Auto-accept privacy on first protected route access.
  // The sign-in page already states "By continuing, you agree to our
  // Terms of Service and Privacy Policy", so a separate modal is redundant.
  useEffect(() => {
    if (user && !privacyAccepted && !loading) {
      void acceptPrivacy();
    }
  }, [user, privacyAccepted, loading, acceptPrivacy]);

  if (loading) {
    return;
  }

  // Auth determined - check auth
  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  // Wait for privacy acceptance to complete before proceeding
  if (!privacyAccepted) {
    return;
  }

  // If onboarding not completed, redirect appropriately
  // Exception: allow /onboarding/* routes through
  if (!onboardingCompleted && !location.pathname.startsWith("/onboarding")) {
    // FS-017 adaptive onboarding entrypoint
    return <Navigate to="/onboarding/intake" replace />;
  }

  return <>{children}</>;
};
